<template>
    <b-container>
        <b-card v-if="wardId !== null">
        <b-breadcrumb>
            <b-breadcrumb-item :to="{name: 'ward-list', params: { wardId: wardId}}">Back to {{ward.ward_name}}</b-breadcrumb-item>
            <b-breadcrumb-item :to="{name: 'ward-bulk-import-list', params: { wardId: wardId}}">Bulk Contact Uploads</b-breadcrumb-item>
            <b-breadcrumb-item active>{{importRequestDetail.original_file_name}}</b-breadcrumb-item>
        </b-breadcrumb>
        </b-card>
        <b-card class="mt-3">
            <b-row>
                <b-col>
                    <h5>Spreadsheet Name: {{importRequestDetail.original_file_name}}</h5>
                    <h5>Has Header: {{(importRequestDetail.file_has_header ? 'Yes': 'No')}}</h5>
                    <h5>Import State: <b-badge :variant="chooseColor()">{{importRequestDetail.import_status}}</b-badge></h5>
                    <h5>Total Records: <b-badge variant='info'>{{importRequestDetail.number_of_contacts}}</b-badge></h5>
                </b-col>
                <b-col>
                    <h5>Pending Records: <b-badge variant='secondary'>{{importRequestDetail.pending_contacts}}</b-badge></h5>
                    <h5>Success Records: <b-badge variant='success'>{{importRequestDetail.good_contacts}}</b-badge></h5>
                    <h5>Failed Records: <b-badge variant='danger'>{{importRequestDetail.error_contacts}}</b-badge></h5>
                    <b-button 
                        v-if="importRequestDetail.import_status ==='PENDING'"
                        @click="doImportProcess" 
                        class="float-left" 
                        type="button" 
                        variant="primary">
                    <font-awesome-icon icon="file-import" />
                    Process Spreadsheet
                    </b-button>
                    <b-button 
                        v-if="importRequestDetail.import_status ==='FINISHED' && !importRequestDetail.consent_queued && importRequestDetail.good_contacts>0"
                        @click="queueSmsAlert" 
                        class="float-left" 
                        type="button" 
                        variant="secondary">
                    <font-awesome-icon icon="sms" />
                    Send Consent
                    </b-button>                    
                </b-col>
            </b-row>
            <b-row>
                <WardImportRequestContacts :importRequestId="importRequestId"/>
            </b-row>
        </b-card>
    </b-container>
</template>
<script>
import { WardApi } from '@/app/wards/wardApi';
import handleError from "@/errorHandler";
import WardImportRequestContacts from "@/app/wards/WardImportRequestContacts"

export default {
    name: "WardImportRequestDetail",
    components: {WardImportRequestContacts},
    props: {
        wardId: {
            type: String,
            required: false
        },
        importRequestId: {
            type: String,
            required: false
        }
    },
    computed: {},
    data () {
        return {
            ward: {
                ward_name: null
            },
            importRequestDetail: {
                import_status: 'PENDING'

            },
            state_colors: {
                'PENDING': 'secondary',
                'PROCESSING': 'warning',
                'FINISHED': 'success',
                'FAILED': 'danger'
            }
        }
    },
    async mounted() {
        if(this.wardId!==null)
            this.ward = await this.getWard();
        if(this.importRequestId!==null)
            this.importRequestDetail = await this.getImportRequest();
    },
    methods: {
        chooseColor() {
            return this.state_colors[this.importRequestDetail.import_status];
        },
        async getWard() {
            try{
                const { data } = await WardApi.getWardDetail(this.wardId);
                return data.ward;
            } catch(e) {
                handleError(e, "Error trying to get Ward Information");
            }
        },
        async getImportRequest() {
            try {
                const { data } = await WardApi.getImportRequest(this.wardId, this.importRequestId);
                return data;
            } catch(e) {
                handleError(e, "Error trying to get Import Request Detail");
            }
        },
        async doImportProcess() {
            try {
                const { data } = await WardApi.performImportRequest(this.wardId, this.importRequestId);
                this.$router.push({ name: 'ward-bulk-import-list',params: { wardId: this.wardId, initImportState: 'FINISHED'}});
            } catch (e) {
                handleError(e, "Error trying to import the spreadsheet");
            }
        },
        async queueSmsAlert() {
            try {
                const { data } = await WardApi.performingBulkSmsRequest(this.wardId, this.importRequestId);
                this.$router.push({ name: 'ward-bulk-import-list',params: { wardId: this.wardId, initImportState: 'FINISHED'}});
            } catch (e) {
                handleError(e, "Error trying to queue SMS for spreadsheet");
            }            
        }
    }


}
</script>
